import Repository from '@/repositories/repository'

const MarketsBlogRepository = {
  async getBlogByCategory(queryParams: any = {}, category: string) {
    const pageSize = Number(queryParams.page_size ?? 100)
    let currentPage = Number(queryParams.page ?? 1)
    let totalPages: number | null = null
    const allPosts: any[] = []
    let lastResponse: any = null
    const maxPages = 100

    while (currentPage <= maxPages) {
      const params = {
        ...queryParams,
        page: String(currentPage),
        page_size: String(pageSize)
      }

      const response = await Repository(category, 'post', params)
      lastResponse = response

      const posts = Array.isArray(response?.data) ? response.data : []
      allPosts.push(...posts)

      if (totalPages === null) {
        const totalCount = Number(response?.meta?.count ?? 0)
        if (totalCount > 0) {
          totalPages = Math.ceil(totalCount / pageSize)
        }
      }

      if (totalPages !== null && currentPage >= totalPages) {
        break
      }

      const nextPageRaw = response?.meta?.next_page
      const nextPage =
        typeof nextPageRaw === 'string' ? Number(nextPageRaw) : Number(nextPageRaw ?? 0)

      if (nextPage > 0 && nextPage !== currentPage) {
        currentPage = nextPage
        continue
      }

      break
    }

    return {
      ...(lastResponse ?? {}),
      data: allPosts
    }
  }
}

export default MarketsBlogRepository
